import saville from '../asset/images/sights/saville.jpg'
import londonEye from '../asset/images/sights/london-eye.jpg'
import nationalGallery from '../asset/images/sights/national-gallery.jpg'
import stJames from '../asset/images/sights/st-james.jpg'
import highTea from '../asset/images/sights/high-tea.jpg'
import kew from '../asset/images/sights/kew.jpg'
import mayfair from '../asset/images/sights/mayfair.jpg'


export const sights = {
    'saville': 
    {   'title': 'Saville Row / Jeremy Street',
    'text': 'Escape the frenzy of Piccadilly Circus by ducking into calm and leafy Jermyn Street. Known for its classy gentlemen’s outfitters, you’ll find old-school shirt, shoes and shaving paraphernalia purveyors, plus the excellent cheesemonger Paxton & Whitfield. And when you’re all suited and booted, pop down Duke Street St James’s into Mason’s Yard for an art hit at White Cube gallery.',
    'img': saville
    
},

'london-eye': 
    {
        'title': 'The London Eye',
        'text': 'The London Eye was built to celebrate the year 2000. With its breathtaking views of the Thames, Parliament and Big Ben, it has been a resounding success, especially at night. It’s hard to picture London’s skyline without it. This attraction boasts the title of highest cantilevered observation wheel in the world.',
        'img': londonEye
    
    },

    'national-gallery': 
    {
        'title': 'The National Gallery',
        'text': 'Established in 1824 as a new art collection for the enjoyment and education of all, the National Gallery first consisted of 38 pictures, put on display at a house on Pall Mall while a purpose-built gallery was constructed. There are now over 2,300 works of art, from medieval classics to world-famous pieces by the French Impressionists. The new museum opened in 1838, located in Trafalgar Square because it was deemed to be at the heart of London – easy for rich people to visit from the west by carriage and also convenient for poor people coming by foot from east London.',
        'img': nationalGallery
    
    },
   
    'st-james': 
    {
        'title': "St. James's Park",
        'text': "Take stroll in St. James’ park. Feed the waterfowl, enjoy a coffee in the park café or marvel at the pelicans and parakeets. St James's Park was founded as a deer park for the royal occupants of St James's Palace, and remodelled by John Nash on the orders of George IV. The central lake is home to numerous species of wildfowl, including pelicans that have been kept here since the 17th century, when the Russian ambassador donated several of the bag-jawed birds to Charles II.",
        'img': stJames
    
    },
   
    'high-tea': 
    {
        'title': 'High Tea at The Dorchester',
        'text': "Open since 1931, the magnificent art deco Dorchester hotel is one of the world’s great hotels. It is also one of the best spots in London to enjoy the most famous British ritual – afternoon tea. Especially when combining it with a stroll through London’s Hyde Park.",
        'img': highTea
    
    },
   
    'kew': 
    {
        'title': 'Kew Gardens',
        'text': "Located around 20 minutes outside of London, see the colors of fall at Kew Gardens, part of the Royal Botanical Gardens. With around 14,000 trees – it’s the place to be. Climb the 118 steps up to the Treetop Walkway to watch nature’s greatest art show.",
        'img': kew
    
    },
    
    'mayfair': 
    {
        'title': 'Mayfair / Oxford Street',
        'text': "London's Mayfair district is at the center for luxury shopping and entertainment. Full of expensive housing, five-star hotels, designer shops and fine restaurants. While Oxford Street shops make up the main artery of London shopping. Known as Europe's busiest shopping street, its unrivalled in its offering of cheap high street shopping and jumbo department stores.",
        'img': mayfair
    
    },
}